import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import ProcessingIcon from './ProcessingIcon';
import LinerProgressBar from './LinerProgressBar';
import ProcessingTitle from './ProcessingTitle';
import { makeStyles, Theme } from '@material-ui/core';

interface ProcessingModalPropsType {
  openModal: boolean;
  processType: string; // enum
}

const useStyles = makeStyles((theme: Theme) => ({
  backDrop: {
    backdropFilter: 'blur(23px)',
    backgroundColor: 'rgba(0,0,30,0.4)',
  },
}));

export default function ProcessingModal(props: ProcessingModalPropsType) {
  const { openModal, processType } = props;
  const classes = useStyles();
  return (
    <div>
      <Dialog
        open={openModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{ sx: { width: '400px', maxWidth: '83%', height: 'auto' } }}
        BackdropProps={{
          classes: {
            root: classes.backDrop,
          },
        }}
      >
        <DialogContent style={{ textAlign: 'center', overflow: 'hidden' }}>
          <br />
          <DialogContentText style={{ margin: '0 auto'}} id="alert-dialog-description">
            <ProcessingIcon value={processType} />
          </DialogContentText>
          <DialogContentText mt={4} id="alert-dialog-description">
            <div style={{ fontFamily: 'Medium', color: '#2db5bd', fontSize: '15px' }}>
              {<ProcessingTitle value={processType} />}
            </div>
            <div>
              <span style={{ fontFamily: 'Medium', color: 'gray', fontSize: '15px' }}>لطفا شکیبا باشید...</span>
            </div>

          </DialogContentText>
          <LinerProgressBar value={processType} />
        </DialogContent>
      </Dialog>
    </div>
  );
}
